<svg class="timeline-filled-line" width="3" height="44" viewBox="0 0 3 44" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1.5 1.5L1.5 142" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
</svg>
